// QuillParts/QuillRegistry.ts
import { Quill } from 'react-quill';
import AutoLinks from 'quill-auto-links';
import ImageUploader from 'quill-image-uploader';
import CustomHeader from '../CustomHeader/CuostomHeader';
import CustomEmogjiBlot from '../../QuillCustomEmoji/blots';
import CustomEmoji from '../../QuillCustomEmoji/customEmoji';
import ImageFormat from '../QuillImageResize/baseImageFormat';
import customHr from '../QuillCustomHr/blots';
import Mention from '@components/library/QuillMention/mention';
import MentionBlot from '@components/library/QuillMention/blots';
import XEmbedBlot from '@components/library/QuillWidgetEmbed/XWidgetBlots';
import VideoUploadBlot from '../QuillCustomVideo/VideoUploadBlot';
import '../QuillCustomTable/blots';

export const registerQuillModules = () => {
  // 이미 등록되었는지 확인하여 중복 방지
  if (registerQuillModules.isRegistered) return;

  // Header
  Quill.register(CustomHeader, true);

  // Custom Emoji
  Quill.register(CustomEmogjiBlot, true);
  Quill.register('modules/customEmoji', CustomEmoji);

  // Image Uploader
  Quill.register('modules/imageUploader', ImageUploader);

  // Auto Links
  Quill.register('modules/autoLinks', AutoLinks);
  // Mention 모듈 등록
  Quill.register(MentionBlot, true);
  Quill.register('modules/mention', Mention);

  // Image Format
  Quill.register(ImageFormat, true);

  // Custom HR
  Quill.register({
    'formats/hr': customHr,
  });

  // x widget
  Quill.register({
    'formats/x': XEmbedBlot,
  });

  // Video Upload (직접 업로드 동영상 - <video controls> 태그)
  Quill.register({
    'formats/videoUpload': VideoUploadBlot,
  });

  // Styles
  const AlignStyle = Quill.import('attributors/style/align');
  const BackgroundStyle = Quill.import('attributors/style/background');
  const ColorStyle = Quill.import('attributors/style/color');
  const DirectionStyle = Quill.import('attributors/style/direction');
  const FontStyle = Quill.import('attributors/style/font');

  Quill.register(AlignStyle, true);
  Quill.register(BackgroundStyle, true);
  Quill.register(ColorStyle, true);
  Quill.register(DirectionStyle, true);
  Quill.register(FontStyle, true);

  // Size
  const Size = Quill.import('formats/size');
  Size.whitelist = ['11', '12', '13', '14', '15', '16', '18', '20', '24', '32', '48'];
  Quill.register(Size, true);

  // Custom Attributes
  const Parchment = Quill.import('parchment');
  const Attr = new Parchment.Attributor.Attribute(
    'data-ke-style',
    'data-ke-style',
    {
      scope: Parchment.Scope.BLOCK,
    },
  );
  Quill.register(Attr);

  // 등록 완료 플래그
  registerQuillModules.isRegistered = true;
};

// 등록 상태 플래그
registerQuillModules.isRegistered = false;